import { Action, handleActions } from 'redux-actions'
import {
  getCompanyInfo,
  getCompanyInfoSuccess,
  getCompanyInfoFail,
  updateCompanyInfo,
  updateCompanyInfoSuccess,
  updateCompanyInfoFail,
  setCompanyAdminSelectedCompanyId,
} from './CompanyAdminActions'
import { GetCompanyInfo$Response } from '../../../services/api.types'

class State {
  companyInfo: GetCompanyInfo$Response | null = null
  loading: boolean = false
  saving: boolean = false
  lastUpdated: number | null = null
  selectedCompanyId: string | null = null
}

export const companyAdmin = handleActions<State, any>(
  {
    // --- Get Company Info ---
    [String(getCompanyInfo)]: (state: State): State => ({
      ...state,
      loading: true,
    }),
    [String(getCompanyInfoSuccess)]: (state: State, action: Action<any>): State => ({
      ...state,
      loading: false,
      companyInfo: action.payload || null,
      lastUpdated: Date.now(),
    }),
    [String(getCompanyInfoFail)]: (state: State): State => ({
      ...state,
      loading: false,
      companyInfo: null,
    }),

    // --- Update Company Info ---
    [String(updateCompanyInfo)]: (state: State): State => ({
      ...state,
      saving: true,
    }),
    [String(updateCompanyInfoSuccess)]: (state: State): State => ({
      ...state,
      saving: false,
      lastUpdated: Date.now(),
    }),
    [String(updateCompanyInfoFail)]: (state: State): State => ({
      ...state,
      saving: false,
    }),

    // --- Selected Company ---
    [String(setCompanyAdminSelectedCompanyId)]: (state: State, action: Action<string>): State => ({
      ...state,
      selectedCompanyId: action.payload,
    }),
  },
  new State(),
)

export { State as CompanyAdminState }
